import { Button, Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import { useTranslate } from 'react-admin';
import { CustomBreadcrumbs } from 'src/components/custom-breadcrumbs';
import { DashboardContent } from 'src/layouts/dashboard';
import ErrorPage403 from 'src/pages/error/403';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import { ProxiesPanel } from './proxies/List';
import { PoolsPanel } from './pools/List';
import { ProxyScorePanel } from './proxy-score/ProxyScorePanel';
import { Iconify } from 'src/components/iconify';
import AuditLogDialog from 'src/pages/admin/components/AuditLog/AuditLogDialog';

const PERMISSION_RESOURCE = 'proxy-manager';

type TabValue = 'proxies' | 'pools' | 'proxy-score';

const ProxyManagerPage = () => {
  const translate = useTranslate();
  const [tab, setTab] = useState<TabValue>('proxies');
  const [auditLogOpen, setAuditLogOpen] = useState(false);

  return (
    <DashboardContent>
      <PermissionGuard resource={PERMISSION_RESOURCE} action="read" fallback={<ErrorPage403 />}>
        <CustomBreadcrumbs
          heading={translate('resource.proxyManager', { _: 'Proxy Manager' })}
          action={
            <PermissionGuard resource="audit-logs" action="read" fallback={<></>}>
              <Button
                variant="contained"
                size="medium"
                color="secondary"
                startIcon={<Iconify icon="ph:note" />}
                onClick={() => setAuditLogOpen(true)}
              >
                {translate('resource.auditLogs')}
              </Button>
            </PermissionGuard>
          }
        />

        <Tabs
          value={tab}
          onChange={(_, value: TabValue) => setTab(value)}
          sx={{ mt: 2, borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab
            value="proxies"
            label={translate('module.proxyManager.proxiesTitle', { _: 'Proxies' })}
          />
          <Tab value="pools" label={translate('module.proxyManager.poolsTitle', { _: 'Pools' })} />
          <Tab
            value="proxy-score"
            label={translate('module.proxyManager.proxyScoreTitle', { _: 'Proxy Score' })}
          />
        </Tabs>

        {tab === 'proxies' && <ProxiesPanel />}
        {tab === 'pools' && <PoolsPanel />}
        {tab === 'proxy-score' && <ProxyScorePanel />}

        <AuditLogDialog
          open={auditLogOpen}
          onClose={() => setAuditLogOpen(false)}
          resource="proxy-manager"
          title={`${translate('resource.auditLogs')} - ${translate('resource.proxyManager', { _: 'Proxy Manager' })}`}
        />
      </PermissionGuard>
    </DashboardContent>
  );
};

export default ProxyManagerPage;
